export default __webpack_public_path__ + "static/sz_en_4-fa045afe00eab65207137ee465f878b0.mp4";